import React, { useEffect, useCallback } from "react";

import TemplateIndex from "../../components/TemplateIndex";
import { ICardMenu } from "../../components/CardMenu";
import { GetUser } from "../../services/auth";
import DynamicRepository from "../../Repositories/DynamicRepository";

import { Roles } from "../../interfaces";

const Production: React.FC = () => {

     const whichStatus = useCallback((role: Roles) => {
        switch (role) {
            case "Admin":
            case "Operador":
                return `STATUSKIT == 7`;
            case "GerenteR":
                return `STATUSKIT == 6`;
            case "GerenteS":
                return `STATUSKIT >= 2 && STATUSKIT <= 4`;
            case "Representante":
                return `STATUSKIT == 2 || STATUSKIT == 3`;
            default:
                return `STATUSKIT == -1`;
        }
    }, []);

    const hasKitsToRegionalManagerConference = useCallback(async () => {
        const response = await DynamicRepository.DynamicTotals([{
            dynamicType: "KT",
            returnCode: "KIT",
            filter: `STATUSKIT == 6`
        }]);
        return response.KIT > 0;
    }, []);

    useEffect(() => {
        hasKitsToRegionalManagerConference();
    }, [hasKitsToRegionalManagerConference]);

    let items: ICardMenu[] = [
        {
            path: "/categories",
            icon: "tags",
            text: "Categorias",
            roles: ["Admin"],
            show: true
        },
        {
            path: "/products",
            icon: "gem",
            text: "Produtos",
            roles: ["Admin"],
            show: true
        },
        {
            path: "/stock",
            icon: "boxes",
            text: "Estoque",
            roles: ["Admin"],
            show: false
        },
        {
            path: "/kits",
            icon: "box",
            text: "Kits",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: true
        },
        {
            path: {
                pathname: "/conference",
                state: { status: whichStatus(GetUser().role) }
            },
            icon: "clipboard check",
            text: "Conferência",
            roles: ["Operador", "GerenteS"],
            show: true
        },
        {
            path: {
                pathname: "/conference",
                state: { status: whichStatus(GetUser().role) }
            },
            icon: "clipboard check",
            text: "Conferência",
            roles: ["Representante"],
            show: true            
        },
        {
            path: {
                pathname: "/conferencesectors",
                state: { status: whichStatus(GetUser().role) }
            },
            icon: "clipboard check",
            text: "Conferência",
            roles: ["GerenteR"],
            show: true
        },
        {
            path: "/exchanges",
            icon: "sync alternate",
            text: "Trocas",
            roles: ["Admin", "GerenteS", "Representante", "Operador"],
            show: true
        },
        {
            path: "/operators",
            icon: "users",
            text: "Operadores",
            roles: ["Admin"],
            show: true
        },
        {
            path: "/orders",
            icon: "list alternate",
            text: "Pedidos",
            roles: ["Admin", "Operador", "GerenteS"],
            show: true
        },
    ];

    return <TemplateIndex title="Produção" cards={items} />;
};

export default Production;
